import { useEffect, useRef, useCallback } from 'react';

// 节流函数
function throttle<T extends (...args: any[]) => void>(func: T, limit: number): T {
  let inThrottle = false;
  return ((...args: any[]) => {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  }) as T;
}

interface UseIdleDetectionOptions {
  onActivity?: () => void;
  throttleMs?: number;
}

export const useIdleDetection = (options: UseIdleDetectionOptions = {}) => {
  const { onActivity, throttleMs = 1000 } = options;
  const activityRef = useRef(onActivity);

  // 保持最新的回调引用
  useEffect(() => {
    activityRef.current = onActivity;
  }, [onActivity]);

  // 处理用户活动
  const handleActivity = useCallback(
    throttle(() => {
      activityRef.current?.();
    }, throttleMs),
    [throttleMs]
  );

  useEffect(() => {
    // 监听各种用户活动事件
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'keydown',
      'keyup',
      'touchstart',
      'touchmove',
      'scroll',
      'click',
      'wheel',
    ];

    // 添加事件监听器
    events.forEach((event) => {
      window.addEventListener(event, handleActivity, { passive: true });
    });

    // 清理函数
    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [handleActivity]);
};

export default useIdleDetection;
